<script>
  import { Dropdown, DropdownDivider, DropdownItem } from 'flowbite-svelte';

  /**
   * User's balance object.
   * @type {{ value: number }}
   */
  export let balance = { value: 0 };

  /**
   * User's information.
   * @type {{ first_name: string, last_name: string, email: string }}
   */
  export let user = { first_name: '', last_name: '', email: '' };

  /**
   * Whether the user is logged in.
   * @type {boolean}
   */
  export let loggedIn = false;

  /**
   * Whether the user is logged in.
   * @type {boolean}
   */
  export let balanceTextEnabled = true;

  /**
   * URL of the user's avatar image.
   * @type {string}
   */
  export let currencyText = 'kr.';

  /**
   * Links for the profile when the user is not logged in.
   * @type {{ first: { href: string, label: string }, second: { href: string, label: string } }}
   */
  export let profileLinks = { first: { href: '', label: '' }, second: { href: '', label: '' } };

  /**
   * URL of the user's avatar image.
   * @type {string}
   */
  export let avatarImage = '';
</script>

<div class="profile-avatar {loggedIn ? 'logged-in' : ''}">
  {#if loggedIn}
    <div class="balance-nav">
      {#if balanceTextEnabled}
        Saldo:{/if} <span class="value">{balance?.value?.toFixed(2) ?? 0} {currencyText}</span>
    </div>

    <div class="menu">
      <img src={avatarImage} alt="profile" class="profile" id="avatar" />
      <Dropdown triggeredBy="#avatar">
        <div slot="header" class="info">
          <span class="block name">{user.first_name} {user.last_name}</span>
          <span class="block email">{user.email}</span>
        </div>
        <DropdownDivider />
        <DropdownItem href="/min-konto">Profil</DropdownItem>
        <DropdownDivider />
        <DropdownItem slot="footer">
          <form method="post" action="/?/logout">
            <input class="hover:cursor-pointer" type="submit" value="Log ud" />
          </form>
        </DropdownItem>
      </Dropdown>
    </div>
  {:else}
    <ul class="login">
      <li>
        <a href={profileLinks.first.href}>{profileLinks.first.label} </a>
      </li>
      <li>
        <a href={profileLinks.second.href} class="button login-button">{profileLinks.second.label}</a>
      </li>
    </ul>
  {/if}
</div>
